<template>
  <div>
    <v-container class="mt-lg-10" fluid>
      <v-row dense>
        <v-col>
          <v-card>
            <v-app-bar color="primary" dark>
              <v-icon class="mr-3">mdi-filter</v-icon>
              <v-toolbar-title>Filters</v-toolbar-title>
            </v-app-bar>
            <v-container fluid>
              <v-row dense>
                <v-col :key="idx" cols="12" lg="3" md="3" v-for="(value, key, idx) in filters">
                  <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                     type="card-heading">
                    <v-select :items="value" :label="$t(`msg.${key}_label`)" chips
                              deletable-chips dense outlined small-chips class="contain-long-inputs"
                               v-model="filterBox[`${key}`]"></v-select>
                  </v-skeleton-loader>
                </v-col>

                <v-col cols="12" lg="3" md="3">
                  <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                     type="card-heading">
                    <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px"
                            offset-y transition="scale-transition" v-model="menu1">
                      <template v-slot:activator="{ on }">
                        <v-text-field label="Start Date" append-icon="mdi-calendar" clearable
                                      dense outlined readonly v-model="filterBox.startDate"
                                      v-on="on"></v-text-field>
                      </template>
                      <v-date-picker :max="date" @input="menu1 = false"
                                     v-model="filterBox.startDate"></v-date-picker>
                    </v-menu>
                  </v-skeleton-loader>
                </v-col>

                <v-col cols="12" lg="3" md="3">
                  <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition"
                                     type="card-heading">
                    <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px"
                            offset-y transition="scale-transition" v-model="menu2">
                      <template v-slot:activator="{ on }">
                        <v-text-field label="End Date" append-icon="mdi-calendar" clearable
                                      dense outlined readonly v-model="filterBox.endDate"
                                      v-on="on"></v-text-field>
                      </template>
                      <v-date-picker :max="date" :min="filterBox.startDate"
                                     @input="menu2 = false"
                                     v-model="filterBox.endDate"></v-date-picker>
                    </v-menu>
                  </v-skeleton-loader>
                </v-col>

                <v-col class="d-flex justify-lg-end justify-md-end justify-center">
                  <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition" type="button" class="mr-3">
                    <v-btn @click="resetFilters" color="secondary" dark>{{ $t('reset') }}</v-btn>
                  </v-skeleton-loader>
                  <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition" type="button">
                    <v-btn @click="filterData" color="secondary" dark>{{ $t('filter') }}</v-btn>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="customersTablePadding" fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-app-bar color="primary" dark>
              <v-icon class="mr-3">mdi-account-group</v-icon>
              <v-toolbar-title v-if="showTableHeading">
                <span v-show="userType=='SME'">SME</span>
                <span v-show="userType=='MIKRO'">MIKRO</span>
              </v-toolbar-title>
              <v-toolbar-title v-else>
                <span>List of Test Reports</span>
              </v-toolbar-title>
              <v-row justify="end">
                <v-dialog max-width="450" persistent v-model="appliedDialog">
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" class="hidden-sm-and-down text-left" dark v-on="on">
                      View Applied Filters
                    </v-btn>
                    <v-btn color="secondary" class="hidden-md-and-up" dark v-on="on">
                      <v-icon>
                        mdi-filter
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Filters Applied</v-card-title>
                    <v-card-text>
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                          <tr :key="idx" v-for="(value, key, idx) in filters">
                            <td>{{ $t(`msg.${key}_label`) }}</td>
                            <td>:</td>
                            <td v-if="undefined == appliedFilters[key]">
                              {{ $t(`msg.${key}_all_applied`) }}
                            </td>
                            <td v-else>
                              {{ value.filter(f => f.value === appliedFilters[key])[0].text }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('msg.start_date') }}</td>
                            <td>:</td>
                            <td v-if="appliedFilters.startDate">
                              {{ appliedFilters.startDate }}
                            </td>
                            <td v-else>
                              {{ $t('msg.all_dates') }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('msg.end_date') }}</td>
                            <td>:</td>
                            <td v-if="appliedFilters.endDate">
                              {{ appliedFilters.endDate }}
                            </td>
                            <td v-else>
                              {{ $t('msg.all_dates') }}
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn @click="appliedDialog = false" color="green darken-1" text>Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-app-bar>
            <v-container class="containerStyling">
              <v-row>
                        <span :key="index" v-for="(headers, index) in headers">
                           <v-col v-if="headers.toggle">
                              <v-checkbox :label="headers.text" color="primary"
                                          v-model="headers.selectedCheckbox"
                                          v-on:change="recordTicks()"/>
                           </v-col>
                        </span>
              </v-row>
            </v-container>
            <v-card>
              <v-skeleton-loader :loading="tableDataLoading" transition="scale-transition"
                                 type="table-tbody">
                <v-card-title>
                  <v-row>
                    <v-col md="7"></v-col>
                    <v-text-field hide-details placeholder="Search" single-line
                                  v-model="filterBox.searchText"></v-text-field>
                    <div class="pl-3 mt-2"></div>
                    <v-btn @click="filterData" class="ma-2" dark color="#49abad">
                      <v-icon dark>mdi-magnify</v-icon>
                    </v-btn>
                  </v-row>
                </v-card-title>
              </v-skeleton-loader>
              <v-data-table :disable-sort="true" :footer-props="{
                            'items-per-page-options': pagination.itemPerPageOptions,'show-current-page':true}"
                            :headers="filteredHeaders" :items="table.tableData"
                            :options.sync="pagination" :server-items-length=table.totalLength
                            @update:options="paginate" v-show="!tableDataLoading">
                <template v-slot:item.loan_amount="{ item }">
                  <span v-if="item.loan_amount">
                    {{ item.currency }}&nbsp;{{ item.loan_amount }}
                  </span>
                  <span class="text-center" v-else>
                    <v-icon>mdi-minus</v-icon>
                  </span>
                </template>
                <template v-slot:item.product_applied_label="{ item }">
                  <span v-if="item.product_applied_label">
                    {{ item.product_applied_label }}
                  </span>
                  <span class="text-center" v-else>
                    <v-icon>mdi-minus</v-icon>
                  </span>
                </template>
                <template v-slot:item.test_finish_time="{ item }">
                  <span v-if="item.test_finish_time">
                    {{ item.test_finish_time }}
                  </span>
                  <span class="text-center" v-else>
                    <v-icon>mdi-minus</v-icon>
                  </span>
                </template>
                <template v-slot:item.details="{ item }">
                  <v-icon @click="editItem(item)" class="mr-2" color="#49abad" small
                          v-if="!item.scoring_triggered_by_officer && item.status==='FINISHED'">
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon class="mr-2" color="grey darken-2" small v-else>
                    mdi-square-edit-outline
                  </v-icon>
                </template>
                <template v-slot:item.applicationStatus="{ item }">
                  {{ item.application_status_label }}
                  <v-icon @click="editApplicationStatus(item)" class="mr-2" color="#49abad"
                          small v-if="item.has_gfi_score">mdi-square-edit-outline
                  </v-icon>
                  <v-icon class="mr-2" color="grey darken-2" small v-if="!item.has_gfi_score">
                    mdi-square-edit-outline
                  </v-icon>
                </template>
                <template v-slot:item.scoring="{ item }">
                  <v-icon @click="generateScore(item)" class="mr-2" color="#49abad" small
                          v-if="item.ready_for_scoring && !item.scoring_triggered_by_officer">
                    mdi-calculator
                  </v-icon>
                  <v-icon class="mr-2" color="grey darken-2" small
                          v-if="!item.ready_for_scoring || (item.ready_for_scoring && item.scoring_triggered_by_officer)">
                    mdi-calculator
                  </v-icon>
                </template>
                <template v-slot:item.test_taker_score_overall_rating="{ item }">
                  <span v-if="item.test_taker_score_overall_rating">
                    {{ item.test_taker_score_overall_rating }}
                  </span>
                  <span class="text-center" v-else>
                    <v-icon>mdi-minus</v-icon>
                  </span>
                </template>
                <template v-slot:item.report="{item}">
                  <span v-if="item.has_gfi_score">
                    <span v-if="checkArray(item._id,item.id_number,'BANK_REPORT')">
                      <v-icon @click.native="downloadReport(item._id,item.id_number,'BANK_REPORT')"
                                              color="secondary">mdi-file-download</v-icon>
                    </span>
                    <span v-else>
                      <v-progress-circular :size="20" color="#49abad" indeterminate></v-progress-circular>
                    </span>
                  </span>
                  <span v-else>
                    <v-icon>mdi-file-download</v-icon>
                  </span>
                </template>
              </v-data-table>
            </v-card>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog max-width="450" persistent v-model="dialog" v-if="renderEditForm">
        <v-card>
          <v-card-title class="headline">Edit Customer Information</v-card-title>
          <div class="notes"><b style="color: red">*</b> {{ $t('msg.asterisk_remark') }}</div>
          <v-card-text>
            <ValidationObserver ref="observer" v-slot="{ passes}">
              <form>
                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider :rules="{required: true}" v-slot="{errors, failedRules}">
                    <v-select :error-messages="$translatedErrorMessages(failedRules,'gender')"
                              :items="editGenderFilterDropdownData"
                              item-text="text"
                              item-value="value"
                              label="Gender"
                              chips deletable-chips small-chips
                              class="requiredSticker"
                              v-model="editedItem.gender">
                    </v-select>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <v-menu ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field label="Date of Business Commencement"
                                    class="requiredSticker"
                                    append-icon="mdi-calendar"
                                    clearable readonly
                                    v-model="editedCommencementDate"
                                    v-on="on">
                      </v-text-field>
                    </template>

                    <v-date-picker :max="date"
                                   v-model="editedItem.commencement_date"
                                   @input="menu = false"
                                   no-title scrollable>
                    </v-date-picker>
                  </v-menu>
                </v-skeleton-loader>

                <v-skeleton-loader>
                  <ValidationProvider :rules="{ required: true}"
                                      v-slot="{errors, failedRules}">
                    <v-select
                        :error-messages="$translatedErrorMessages(failedRules,'currency')"
                        :items="editCurrencyDropdownData"
                        item-text="text"
                        item-value="value"
                        label="Preferred Currency"
                        chips
                        deletable-chips
                        small-chips
                        v-model="editedItem.currency"
                        class="requiredSticker"
                    ></v-select>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider :rules="{numeric: false, min_value: 1, max_value: 999999999}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'paidUpCapital')"
                        label="Paid-up Capital Amount "
                        :prefix="editedItem.currency"
                        v-model="editedItem.paid_up_capital"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <v-select
                      :items="businessSizeItems"
                      item-text="text"
                      item-value="value"
                      label="Size Of Business"
                      chips
                      deletable-chips
                      small-chips
                      v-model="editedItem.business_size"
                      class="requiredSticker">
                  </v-select>
                </v-skeleton-loader>

                <v-skeleton-loader>
                    <v-select
                        :items="editBusinessCategoryDropdownData"
                        item-text="text"
                        item-value="value"
                        label="Nature Of Business"
                        chips
                        deletable-chips
                        small-chips
                        v-model="editedItem.business_category"
                        class="requiredSticker"
                    ></v-select>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{numeric: true, min_value:1, max_value:180}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'industryExperience')"
                        label="Years of Industry Experience"
                        v-model="editedItem.industry_experience"
                        class="requiredSticker">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{numeric: true, min_value:1, max_value:1000}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'employeesCount')"
                        class="requiredSticker"
                        label="Full-Time Employees"
                        v-model="editedItem.employees_count">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider
                      :rules="{ integer: true, min_value:-999999999, max_value:999999999}"
                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'annualSales')"
                        class="requiredSticker"
                        label="Annual Sales Turnover"
                        :prefix="editedItem.currency"
                        v-model="editedItem.annual_sales">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider
                      :rules="{ integer: true, min_value:-999999999, max_value:editedItem.annual_sales?editedItem.annual_sales:999999999}"
                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'annualProfit', [editedItem.annual_sales?editedItem.annual_sales:999999999])"
                        label="Annual Profit Before Tax"
                        class="requiredSticker"
                        :prefix="editedItem.currency"
                        v-model="editedItem.annual_profit">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader>
                  <ValidationProvider>
                    <v-select
                        :items="editProductDropDownData"
                        item-text="text"
                        item-value="value"
                        label="Product"
                        chips
                        deletable-chips
                        small-chips
                        class="requiredSticker"
                        @change="handleProductChange"
                        v-model="editedItem.product_applied">
                    </v-select>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{required: true, numeric: true, min_value: validation.minAmount, max_value: validation.maxAmount}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'financingAmount', [validation.minAmount, validation.maxAmount])"
                        label="Loan Amount Required"
                        :prefix="editedItem.currency"
                        class="requiredSticker"
                        v-model="editedItem.loan_amount">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loading"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider :rules="{numeric: true, min_value: validation.minTenure, max_value: validation.maxTenure}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'tenureApplied', [validation.minTenure, validation.maxTenure])"
                        label="Financing Tenure"
                        suffix="Months"
                        class="requiredSticker"
                        v-model="editedItem.tenure_applied">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider :rules="{required: false, numeric: true, min_value:1, max_value:100}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'internalRating')"
                                  label="Organisation Credit Rating"
                                  v-model="editedItem.internal_rating"></v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider :rules="{required: false, numeric: true, min_value:250, max_value:900}"
                                      v-slot="{errors, failedRules}">
                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'cbrRating')"
                                  label="Credit Bureau Rating"
                                  v-model="editedItem.cbr_rating">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-card-actions align="right">
                  <v-spacer></v-spacer>
                  <v-btn @click="clear" dark color="#49abad">Cancel</v-btn>
                  <v-skeleton-loader :loading="loading" transition="scale-transition" type="button">
                    <v-btn @click="passes(updatedItem)" class="ml-4" color="#49abad" dark>
                      Save
                    </v-btn>
                  </v-skeleton-loader>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog max-width="450" persistent v-model="applicationStatusDialog" v-if="renderEditApplicationForm">
        <v-card>
          <v-card-title class="headline">Update Application Status</v-card-title>
          <v-card-text>
            <ValidationObserver ref="updateObserver" v-slot="{failedRules, failed ,passes}">
              <form>
                <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider :rules="{required:true, alpha_num: true, max: 20}"
                                      ref="observerEditApplicationNumber"
                                      v-slot="{errors, failedRules}">
                    <v-text-field vid="applicationNumber"
                                  name="applicationNumber"
                                  :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                                  label="Application No. by FI"
                                  v-model="editApplicationItem.application_number">
                    </v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>

                <v-skeleton-loader
                    :loading="loadingFilterData"
                    transition="scale-transition"
                    type="list-item-two-line">
                  <ValidationProvider rules="required" v-slot="{errors, failedRules}">
                    <v-select
                        :error-messages="$translatedErrorMessages(failedRules,'customerApplicationStatus')"
                        :items="filters.applicationStatus"
                        item-text="text"
                        item-value="value"
                        label="Application Status"
                        v-model="editApplicationItem.application_status"
                    >
                    </v-select>
                  </ValidationProvider>
                </v-skeleton-loader>

                <div v-if="editApplicationItem.application_status==='A'">
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="list-item-two-line">
                    <ValidationProvider :rules="{numeric:true,required:true, min_value: 1, max_value: 999999999 }"
                                        v-slot="{errors, failedRules}">
                      <v-text-field
                          :error-messages="$translatedErrorMessages(failedRules,'financingAmountApproved')"
                          label="Financing Amount Approved"
                          :prefix="editedItem.currency"
                          v-model="editApplicationItem.financing_amount_approved">
                      </v-text-field>
                    </ValidationProvider>
                  </v-skeleton-loader>
                  <v-skeleton-loader
                      :loading="loadingFilterData"
                      transition="scale-transition"
                      type="list-item-two-line">
                    <ValidationProvider :rules="{numeric:true,required: true, min_value: 1, max_value: 180 }"
                                        v-slot="{errors, failedRules}">
                      <v-text-field
                          :error-messages="$translatedErrorMessages(failedRules,'tenureApproved')"
                          label="Tenure Approved" suffix="Months"
                          v-model="editApplicationItem.tenure_approved">
                      </v-text-field>
                    </ValidationProvider>
                  </v-skeleton-loader>
                </div>

                <ValidationProvider :rules="{required: false, numeric: true,  min_value:1, max_value:100}"
                                    v-slot="{errors, failedRules}">
                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'internalRating')"
                                label="Organisation Credit Rating"
                                v-model="editApplicationItem.internal_rating"></v-text-field>
                </ValidationProvider>

                <ValidationProvider :rules="{required: false, numeric: true,  min_value:250, max_value:900}"
                                    v-slot="{errors, failedRules}">
                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'cbrRating')"
                                label="Credit Bureau Rating"
                                v-model="editApplicationItem.cbr_rating">
                  </v-text-field>
                </ValidationProvider>
              </form>
              <v-card-actions align="right">
                <v-spacer></v-spacer>
                <v-btn @click="clearApplicationStatusUpdate" dark color="#49abad">Cancel</v-btn>
                <v-skeleton-loader :loading="loadingFilterData" transition="scale-transition" type="button">
                  <v-btn @click="passes(updateApplicationStatus)" class="ml-4" color="#49abad" dark>
                    Save
                  </v-btn>
                </v-skeleton-loader>
              </v-card-actions>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog max-width="700" persistent v-model="generateScoreDialog">
        <v-card>
          <v-card-title class="headline">Generate Score</v-card-title>
          <v-card-text>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field label="Gender" readonly v-model="editedItem.gender_label"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field label="Identification Number (ID)" readonly v-model="editedItem.id_number">
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field label="Date of Commencement" readonly
                                  v-model="editedItem.formatted_commencement_date"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field label="Preferred Currency" readonly v-model="editedItem.currency">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="Paid-up Capital Amount" readonly
                                  v-model="editedItem.paid_up_capital"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="Business Size" readonly
                                  v-model="editedItem.business_size"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field label="Nature Of Business" readonly
                                  v-model="editedItem.business_category_label"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="Years of Industry Experience" readonly
                                  v-model="editedItem.industry_experience"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="Product Applied" readonly
                                  v-model="editedItem.product_applied_label">
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field label="Financing Amount Applied"
                        :prefix="editedItem.currency"
                        readonly
                        v-model="editedItem.loan_amount"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="Tenure Applied" readonly suffix="Months"
                                  v-model="editedItem.tenure_applied"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="Number of full-time employee" readonly
                                  v-model="editedItem.employees_count"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field label="Annual Sales" readonly
                                  v-model="editedItem.annual_sales"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field label="Annual Profit" readonly
                                  v-model="editedItem.annual_profit"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            Are you sure you want to generate GFI scores for this issuer?
            <br/>Please note that you will not be able to change the issuer details after scores have been
            generated.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="generateScoreDialog=false" dark color="#49abad" right>Cancel</v-btn>
            <v-btn @click="sendGenerateScoreReqeust" class="mr-4" color="#49abad" dark right>Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-snackbar
        :right="'right'"
        :timeout=4000
        :top="'top'"
        color="success"
        v-model="updated">
      Successfully Updated.
    </v-snackbar>
    <v-snackbar
        :right="'right'"
        :timeout=4000
        :top="'top'"
        color="success"
        v-model="generateScoreSnackbar">
      Successfully Triggered Generate Scores.
    </v-snackbar>
    <v-snackbar
        :right="'right'"
        :timeout=2000
        :top="'top'"
        color="success"
        v-model="deletedSnackbar">
      Successfully Removed.
    </v-snackbar>
    <v-snackbar :bottom="true" :right="true" :timeout="6000" :vertical="true" color="info"
                v-model="reportDownloadError">
      <span v-html="$t('msg.report_unavailable')"></span>
      <v-btn @click="reportDownloadError = false" dark text v-html="$t('msg.close_label')"></v-btn>
    </v-snackbar>
    <v-snackbar :bottom="true" :right="true" :timeout="6000" :vertical="true" color="info"
                v-model="exportDataDownloadError">
      <span v-html="$t('msg.export_unavailable')"></span>
      <v-btn @click="exportDataDownloadError = false" dark text v-html="$t('msg.close_label')"></v-btn>
    </v-snackbar>
    <v-snackbar
        v-model="endDateSnackBar"
        :multi-line="true"
        :top="true"
        :timeout="3000"
    >
      Please select Start Date First

      <template v-slot:action="{ attrs }">
        <v-btn
            color="black"
            dark
            text
            v-bind="attrs"
            @click="endDateSnackBar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import {dataServices, downloadFileService} from "../../services/index";
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import debounce from 'lodash/debounce'
import fileSaver from 'file-saver'

export default {
  name: 'UserList',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    userType: {
      type: String,
      default: 'SME',
      required: true
    }
  },
  data() {
    return {
      renderEditForm: true,
      renderEditApplicationForm: true,
      reportDownloadError: false,
      exporting: false,
      exportDataDownloadError: false,
      hideColumn: false,
      loadingFilterData: true,
      tableDataLoading: true,
      loading: false,
      selectedSchedule: '',
      appliedFilters: {},
      profile: {},
      results: {},
      editedItem: {},
      editedCommencementDate: '',
      editApplicationItem: {},
      schedules: [],
      table: {
        tableData: [],
        totalLength: 0
      },
      filters: {},
      editGenderFilterDropdownData: [],
      editBusinessCategoryDropdownData: [],
      editProductDropDownData: [],
      editEthnicityDropdownData: [],
      editCurrencyDropdownData: [
        {
          text: 'USD',
          value: 'USD',
        },
        {
          text: 'OMR',
          value: 'OMR',
        },
      ],
      internalRatingAvailableItems: [
        {text: 'Yes', value: 'Y'},
        {text: 'No', value: 'N'}
      ],
      cbrRatingAvailableItems: [
        {text: 'Yes', value: 'Y'},
        {text: 'No', value: 'N'}
      ],
      businessSizeItems: [
        {text: 'Micro', value: 'MICRO'}
      ],
      date: new Date().toISOString().substr(0, 10),
      validation: {},
      newDate: '',
      menu: false,
      modal: false,
      menu2: false,
      menu1: false,
      dialog: false,
      applicationStatusDialog: false,
      appliedDialog: false,
      deletedDialog: false,
      generateScoreDialog: false,
      updated: false,
      deletedSnackbar: false,
      generateScoreSnackbar: false,
      endDateSnackBar: false,
      moreThanTwo: false,
      requestDataArray: [''],
      items: [
        {text: 'Home', disabled: true, href: 'breadcrumbs_dashboar'},
        {text: 'Manage', disabled: true, href: 'breadcrumbs_link_1'}
      ],
      headers: [
        {
          position: 1,
          text: this.$t('msg.sl_no'),
          align: 'left',
          selectedCheckbox: true,
          toggle: false,
          value: 'slno'
        },
        {
          position: 2,
          text: this.$t('msg.id_number'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'id_number'
        },
        {
          position: 3,
          text: this.$t('msg.product_applied'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'product_applied_label'
        },
        {
          position: 4,
          text: this.$t('msg.financing_amount_requested'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'loan_amount'
        },
        {
          position: 5,
          text: this.$t('msg.gfi_completion_date'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'test_finish_time'
        },
        {
          position: 6,
          text: this.$t('msg.gfi_status'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'completion_status'
        },
        {
          position: 7,
          text: this.$t('msg.update_details'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'details'
        },
        {
          position: 8,
          text: this.$t('msg.gfi_scoring'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'scoring'
        },
        {
          position: 9,
          text: this.$t('msg.application_status'),
          align: 'center',
          selectedCheckbox: true,
          toggle: false,
          value: 'applicationStatus'
        },
        {
          position: 10,
          text: this.$t('msg.gfi_rating'),
          value: 'test_taker_score_overall_rating',
          selectedCheckbox: true,
          toggle: false
        },
        {position: 11, text: this.$t('msg.report'), value: 'report', selectedCheckbox: true, toggle: false},
      ],
      checkItemArray: [],
      clickedItem: {},
      pagination: {
        itemsPerPage: 10,
        itemPerPageOptions: [10]
      },
      filterBox: {}
    }
  },
  methods: {
    showColumn: function (col) {
      return this.headers.find(h => h.value === col).selected
    },
    hideColumnData: function () {
      this.hideColumn = !this.hideColumn
    },
    prepareDataForRequest: function () {
      let request = Object.assign({}, this.appliedFilters)
      request.pageSize = this.pagination.itemsPerPage
      request.pageNumber = this.pagination.page
      request.financeType = this.userType.toUpperCase()
      return request
    },
    getDataFromApi: function () {
      console.log('data for' + this.userType)
      let data = this.prepareDataForRequest()
      dataServices.getDataForCustomers(data).then(response => {
        this.table.tableData = response.dataResponse.resultData.table_content
        this.table.totalLength = response.dataResponse.resultData.total_rows
        this.tableDataLoading = false
      })
    },
    getDropDownData: function () {
      if (this.userType === 'MIKRO') {
        dataServices.getMikroDataForFilters().then(response => {
          this.populateDropdownData(response)
          this.loadingFilterData = false
        })
      } else if (this.userType === 'SME') {
        dataServices.getSmeDataForFilters().then(response => {
          this.populateDropdownData(response)
          this.loadingFilterData = false
        })
      }
    },
    populateDropdownData: function (response) {
      this.filters = response.dataResponse
    },
    getEditFilterDropdownData: function () {
      dataServices.getDataForEditFilters().then(response => {
        if (null != response.dataResponse.editGenderDropDownData) {
          this.editGenderFilterDropdownData = response.dataResponse.editGenderDropDownData
        }
        if (null != response.dataResponse.editBusinessDropDownData) {
          this.editBusinessCategoryDropdownData = response.dataResponse.editBusinessDropDownData
        }
        if (null != response.dataResponse.editProductDropDownData) {
          this.editProductDropDownData = response.dataResponse.editProductDropDownData
        }
        if (null != response.dataResponse.editEthnicityDropDownData) {
          this.editEthnicityDropdownData = response.dataResponse.editEthnicityDropDownData
        }
        this.validation.minAmount = 10000
        this.validation.maxAmount = 500000
        this.validation.minTenure = 1
        this.validation.maxTenure = 36
        this.loading = false
      })
    },
    updateUserInformation: function () {
      dataServices.editUserInformation(this.editedItem).then(() => {
        this.paginate()
        this.updated = true
        this.dialog = false
      }).catch(error => {
        console.log('Error' + error)
      })
    },
    updateCustomerApplicationStatus: function () {
      dataServices.editApplicationStatus(this.editApplicationItem).then(response => {
        if (response.successful) {
          this.paginate()
          this.updated = true
          this.applicationStatusDialog = false
          this.clearApplicationStatusUpdate()
        } else {
          response.errorList.forEach(e => {
            if (e.field === 'applicationNumber' && e.rule === 'duplicate') {
              this.$refs.observerEditApplicationNumber.applyResult({
                errors: ['error'],
                failedRules: ['duplicate']
              });
            }
          })
        }
      }).catch(error => {
        console.log('error' + error)
      })
    },
    editItem: function (item) {
      this.dialog = true
      this.editedItem = Object.assign({}, item)
      if (this.editedItem.commencement_date) {
        const [year, month, day] = this.editedItem.commencement_date.substr(0, 10).split('-')
        this.editedCommencementDate = `${day}-${month}-${year}`
      } else
        this.editedCommencementDate = ''
      this.getEditFilterDropdownData()
    },
    editApplicationStatus: function (item) {
      this.applicationStatusDialog = true
      this.editApplicationItem = Object.assign({}, item)
    },
    updatedItem: function () {
      this.updateUserInformation()
    },
    updateApplicationStatus: function () {
      this.updateCustomerApplicationStatus()
    },
    filterData: function () {
      this.appliedFilters = Object.assign({}, this.filterBox)
      this.pagination.page = 1
      this.paginate()
    },
    resetFilters: function () {
      this.appliedFilters = {}
      this.filterBox = {}
      this.pagination.page = 1
      this.paginate()
    },
    paginate: function () {
      this.tableDataLoading = true
      this.getDataFromApi()
    },
    generateScore: function (item) {
      this.generateScoreDialog = true
      this.editedItem = Object.assign({}, item)
    },
    sendGenerateScoreReqeust: function () {
      dataServices.scoreCustomer(this.editedItem).then(() => {
        this.paginate()
        this.generateScoreDialog = false
        this.generateScoreSnackbar = true
      }).catch(error => {
        console.log('Error' + error)
      })
    },
    downloadReport: function (ttid, idNumber, reportType) {
      this.reportDownloadError = false
      let loaderString = ttid + '-' + idNumber + '-' + reportType
      if (this.requestDataArray.indexOf(loaderString) < 0) {
        this.requestDataArray.push(loaderString)
      }
      downloadFileService.downloadReport({id: ttid})
          .then(response => {
            if (response) {
              fileSaver.saveAs(response, idNumber + '.pdf')
            }
            this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
            this.loading = false
          }).catch(error => {
        this.loading = false
        this.requestDataArray.splice(this.requestDataArray.indexOf(loaderString), 1)
        this.reportDownloadError = true
        console.log('loggin response ' + error)
      })
    },
    checkArray: function (ttid, idNumber, reportType) {
      return this.requestDataArray.indexOf(ttid + '-' + idNumber + '-' + reportType) < 0
    },
    recordTicks: function () {
      let selectedColumns = this.headers
          .filter(header => (header.toggle && header.selectedCheckbox))
          .map(function (header) {
            return header.position
          })
      this.$cookies.set('gfi-starter-plus-' + this.userType, JSON.stringify(selectedColumns))
    },
    clear: function () {
      this.renderEditForm = false
      this.$nextTick(() => {
        this.renderEditForm = true;
      });
      this.dialog = false
    },
    clearApplicationStatusUpdate: function () {
      this.renderEditApplicationForm = false
      this.$nextTick(() => {
        this.renderEditApplicationForm = true;
      });
      this.applicationStatusDialog = false
    },
    handleProductChange () {
      console.log('changes')
      this.validation = this.editProductDropDownData.filter(p => p.value === this.editedItem.product_applied)[0].validation
    }
  },
  computed: {
    filteredHeaders: function () {
      let role = this.$store.state.home.user.role
      let columnsForRole = this.headers.filter(function (e) {
        if (!e.roles || e.roles.length === 0) {
          return true
        } else if (e.roles.includes(role)) {
          return true
        } else {
          return false
        }
      });
      return columnsForRole.filter(h => h.selectedCheckbox)
    },
    isUserAuthenticated() {
      return this.$store.state.home.authenticated
    },
    showTableHeading() {
      return this.$store.state.home.user.products.length > 1
    }
  },
  created() {
    this.getDropDownData()
    this.getDataFromApi()
    if (this.$cookies.get('gfi-starter-plus-' + this.userType)) {
      let selectedColumns = JSON.parse(this.$cookies.get('gfi-starter-plus-' + this.userType))
      for (let i = 0; i < this.headers.length; i++) {
        if (selectedColumns.includes(this.headers[i].position)) {
          this.headers[i].selectedCheckbox = true
        }
      }
    }
  },
  watch: {
    'editedItem.commencement_date': function () {
      if (this.editedItem.commencement_date) {
        const [year, month, day] = this.editedItem.commencement_date.substr(0, 10).split('-')
        this.editedCommencementDate = `${day}-${month}-${year}`
      } else
        this.editedCommencementDate = ''
    },
    editedCommencementDate: function (newCommencementDate) {
      if (!newCommencementDate) {
        this.editedItem.commencement_date = null
      }
    },
    'filterBox.searchText': debounce(function (newValue) {
      if (newValue === '') {
        this.getDataFromApi()
      }
    }, 900),
    userType: function () {
      this.getDropDownData()
      this.resetFilters()
      this.$forceUpdate();
    },
    'filterBox.startDate': function () {
      let date = new Date(this.filterBox.startDate)
      date.setFullYear(date.getFullYear(), 11, 31)
      if (date.getFullYear() < new Date().getFullYear()) {
        this.newDate = date.toJSON()
      } else {
        this.newDate = this.date
      }

      if (this.filterBox.startDate === '' || this.filterBox.startDate === null) {
        this.filterBox.endDate = ''
        this.newDate = this.date
      }
    },
    'filterBox.endDate': function () {
      if (this.filterBox.startDate === '' || this.filterBox.startDate === null) {
        if (this.filterBox.endDate !== '') {
          this.filterBox.endDate = ''
          this.endDateSnackBar = true
        }
      }
    }
  },
}
</script>
<style>
.containerStyling {
  margin-top: 0px;
  margin-bottom: 0px;
}

.customersTablePadding {
  padding-top: 0px;
  padding-bottom: 100px;
}

.requiredSticker label::after {
  content: "*";
  color: red;
}

.notes {
  padding-left: 27px;
  margin-top: -15px;
  font-size: 12px;
  color: grey;
  padding-top: 10px;
  padding-bottom: 15px;
}
/*.v-application .primary--text {
    color: #81c342 !important;
    caret-color: #81c342 !important;
}*/
</style>/